import { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import SearchCard from "./SearchCard";

function getQueryParam(url, paramName) {
  // Create a URL object from the string
  const urlObj = new URL(url);
  // Use URLSearchParams to get the desired parameter
  return urlObj.searchParams.get(paramName);
}

function setQueryParam(param, newValue, reloadPage = true) {
  let currentUrl = new URL(window.location);
  currentUrl.searchParams.set(param, newValue);

  if (reloadPage) {
    window.location.href = currentUrl.href;
  } else {
    window.history.pushState({ path: currentUrl.href }, "", currentUrl.href); 
  }
}

function SearchPage({ itemsPerPage, type, data }) {
  const [pages, setPages] = useState(50);
  const [suggested, setSuggested] = useState("");
  const [totalResults, setTotalResults] = useState(50);
  const URLquery = (getQueryParam(window.location.href, "query")) ? getQueryParam(window.location.href, "query") : 'null'
  const [items, setItems] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [query, setQuery] = useState(URLquery);
  const [inputValue, setInputValue] = useState(URLquery);
  const [resultsStart, setResultsStart] = useState(1);
  const [resultsEnd, setResultsEnd] = useState(itemsPerPage);
  const [scope, setScope] = useState("");  
  const API_URL = data.split("?")[0];
  const [currentPage, setCurrentPage] = useState(0); 
  const emptyResults = [];
  let resultCount = 0;

  /* Load the  dataset */
  useEffect(() => {
    data =
      API_URL +
      "?" +
      "collection=sio~sp-sio-website" +
      "&query=" +
      query +
      "&start_rank=" +
      resultsStart + 
      "&scope=" +
      scope;
    fetch(data)
      .then((response) => response.json())
      .then((data) => {
        data = data.response.resultPacket;
        if (data !== null) {
          if (data.spell) {
            setSuggested(data.spell.text);
          }
          setPages(Math.ceil(data.resultsSummary.fullyMatching / itemsPerPage));
          setTotalResults(data.resultsSummary.fullyMatching);
          resultCount = data.resultsSummary.fullyMatching;
          calculateResultEnd()
          setItems(data.results);
          fadeElementInOut();
        } else {
          setTotalResults(0);
          setPages(1);
          setItems(emptyResults);
          fadeElementInOut();
        }
      })
      .catch((error) => console.error("Failed to load the dataset:", error));
   }, [resultsStart, query , scope]);

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = items.slice(itemOffset, endOffset);

  const handlePageClick = (event) => {
    let resultsStart = (event.selected * 10 + 1).toString();
    setResultsStart(resultsStart); 
    
    setCurrentPage(event.selected);
    console.log(currentPage)
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);

    /*Scroll newly selected results into view */
    const cardListingElement = document.getElementById("main-content");
    cardListingElement.scrollIntoView({ behavior: "smooth" });
  };

  // Function to handle form submission
  const handleFormSubmit = (event) => {
    event.preventDefault();  
    setResultsStart(1);
    setCurrentPage(0);
    setQuery(inputValue);  
    setQueryParam("query", inputValue, false);
  };

  // Function to handle changes in the input
  const handleInputChange = (event) => {
    setInputValue(event.target.value); 
  };

  const handlePageChange = ({ selected: selectedPage }) => {
    setCurrentPage(selectedPage);
  };

  function calculateResultEnd() {
    const toCount = parseInt(resultsStart) + parseInt(itemsPerPage - 1);
    (toCount > resultCount) ? setResultsEnd(resultCount) : setResultsEnd(toCount);
  }

  function fadeElementInOut() {
    const element = document.querySelector(".results-cards");
    element.style.opacity = 0.25;
    setTimeout(() => {
      element.style.opacity = 1;
    }, 250);
  }

  return (
    <>
      <form onSubmit={handleFormSubmit}>
        <div className="search-form relative w-2/3 max-mdlg:w-auto">
          <input 
            type="text" 
            value={inputValue}
            onChange={handleInputChange}
            className="bg-white border border-1 border-primary-purple"
          />
          <button title="Search" className="fill-primary-orange hover:fill-primary-purple focus:fill-primary-purple">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488.4 488.4">
              <g>
                <g>
                  <path d="M0,203.25c0,112.1,91.2,203.2,203.2,203.2c51.6,0,98.8-19.4,134.7-51.2l129.5,129.5c2.4,2.4,5.5,3.6,8.7,3.6
                    s6.3-1.2,8.7-3.6c4.8-4.8,4.8-12.5,0-17.3l-129.6-129.5c31.8-35.9,51.2-83,51.2-134.7c0-112.1-91.2-203.2-203.2-203.2
                    S0,91.15,0,203.25z M381.9,203.25c0,98.5-80.2,178.7-178.7,178.7s-178.7-80.2-178.7-178.7s80.2-178.7,178.7-178.7
                    S381.9,104.65,381.9,203.25z"/>
                </g>
              </g>
            </svg>
          </button>
        </div>
      </form>
      <div className="search-results">
        <div className="results-query py-4">
          {
            (!totalResults) ? <p>No results found for <strong>{query}</strong></p> : 
            <p>Displaying <strong>{resultsStart}</strong> to <strong>{resultsEnd}</strong> of <strong>{totalResults}</strong> results for <strong>{query}</strong></p>
          }

          {suggested && !totalResults && (
            <p>
              Did you mean{" "}
              <span
                className="search-suggestion"
                onClick={() => {
                    setQuery(suggested)
                    setInputValue(suggested)
                  }
                }
              >
                {suggested}
              </span>
              ?
            </p>
          )}
        </div>

        <div className="results-cards">
            {currentItems.map((item, index) => {
                return (
                  <SearchCard
                    key={index}
                    url={item.liveUrl}
                    title={item.title}
                    fileType={item.fileType}
                    fileSize={item.fileSize}
                    summary={item.summary}
                    displayUrl={item.displayUrl}
                  />
                );
              }
            )}
        </div>
      </div>
      <div className="pages">
        <ReactPaginate
          breakLabel=""
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          marginPagesDisplayed={0}
          pageCount={pages}
          previousLabel=""
          previousLinkClassName="prev"
          nextLabel=""
          nextLinkClassName="next"
          activeClassName="active"
          renderOnZeroPageCount={null}
          forcePage={currentPage}
        />
      </div>
    </>
  );
}

export { SearchPage };